import type { ScaleLinear } from 'd3-scale'

type GridLinesProps = {
  scale: ScaleLinear<number, number>
  width: number
  /** Number of ticks (default 5) */
  ticks?: number
}

/**
 * Renders horizontal grid lines at scale tick positions.
 * Should be rendered first in the SVG so other elements appear on top.
 */
function GridLines({ scale, width, ticks = 5 }: Readonly<GridLinesProps>) {
  const tickValues = scale.ticks(ticks)

  return (
    <g className="grid-lines" style={{ pointerEvents: 'none' }}>
      {tickValues.map((v) => (
        <line key={`grid-${v}`} stroke="#e5e7eb" strokeWidth={1} x1={0} x2={width} y1={scale(v)} y2={scale(v)} />
      ))}
    </g>
  )
}

export default GridLines
